import React, { useEffect, useState, useRef } from 'react';
import logo from '../../assets/images/Subtract.png';
import robot from '../../assets/images/bot-icon-bg.png';
import asideLogo from '../../assets/images/robot-profile.png';
import arrowRight from '../../assets/images/right.png';
import bot from '../../assets/images/bot-logo.png';
import whatsApp from '../../assets/images/whatsapp.png';
import telegram from '../../assets/images/telegram.png';
import caller from '../../assets/images/caller.png';
import message from '../../assets/images/message.png';
import smScanner from '../../assets/images/sm-scanner.png';
import closeIcon from "../../assets/images/close-icon.png"
// import QRScanner from "../../assets/images/QR-scanner.png";
import modalClose from "../../assets/images/modal-close.png";
import aiRightArrow from "../../assets/images/ai-right-arrow.png";
import comingSoonScanner from "../../assets/images/coming-soon-scanner.png";
import "./nisg.scss";
import "./chatbot.scss";
import "../../assets/fonts/Typography.scss";
import NISGComp from './NISGComp';

const NISG = () => {

    const [isRight, setIsRight] = useState(false);
    const [isScannerWhatsapp, setIsScannerWhatsapp] = useState(false);
    const [isScannerOpen, setIsScannerOpen] = useState(false);
    const [modalBot, setModalBot] = useState(false);
    const [temp, setTemp] = useState(false);
    const [temp1, setTemp1] = useState(false);
    const [disclaimerSelected, setDisclaimerSelected] = useState(false);
    const [modalChatBot, setModalChatBot] = useState(false);


    useEffect(() => {
        // if (!isRight) {
        const timer = setTimeout(() => {
            setIsRight(true);
        }, 5000);

        return () => clearTimeout(timer);
        // }
    }, []);

    useEffect(() => {
        const mediaQuery768 = window.matchMedia('(max-width: 768px)');
        const mediaQuery1024 = window.matchMedia('(max-width: 1024px)');

        const handleMediaQueryChange = () => {
            if (mediaQuery768.matches) {
                setTemp(true);
            } else {
                setTemp(false);
            }

            if (mediaQuery1024.matches) {
                setIsRight(true);
            } else {
                setIsRight(false);
            }
        };

        // Set initial state based on the current screen size
        handleMediaQueryChange();

        // Add event listeners for changes in screen size
        mediaQuery768.addListener(handleMediaQueryChange);
        mediaQuery1024.addListener(handleMediaQueryChange);

        // Cleanup event listeners on unmount
        return () => {
            mediaQuery768.removeListener(handleMediaQueryChange);
            mediaQuery1024.removeListener(handleMediaQueryChange);
        };
    }, []);


    useEffect(() => {
        const setDynamicHeight = () => {
            const deviceHeight = window.innerHeight;
            const root = document.documentElement;
            root?.style.setProperty("--mobile-height", `${deviceHeight}px`);
        };

        setDynamicHeight();

        window.addEventListener('resize', setDynamicHeight);
        window.addEventListener('orientationchange', setDynamicHeight);

        return () => {
            window.removeEventListener('resize', setDynamicHeight);
            window.removeEventListener('orientationchange', setDynamicHeight);
        };
    }, []);

    const handleClose = (e) => {
        if (e.target.classList.contains('modal-overlay')) {
            setModalBot(false);
            setModalChatBot(false);
        }
    };
    const handleCloseChatBot = (e) => {
        if (e.target.classList.contains('modal-overlay')) {
            setModalChatBot(false);
            window.location.reload();
        }
    };

    const handleChannelButton = () => {
        const disclaimerCookie = getCookieValue("disclaimer");

        if (getCookieValue("appState") && getCookieValue("appState") === "chatTrue" && disclaimerCookie === "true") {
            setModalChatBot(true);
        } else {
            setModalBot(true);
        }
    }
    const handleChatButton = () => {
        if (disclaimerSelected) {
            document.cookie = "disclaimer=true; path=/; max-age=31536000";
            setModalChatBot(true);
            setModalBot(false);
        }
    };

    function getCookieValue(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');

        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i].trim();
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }

    // Function to continuously monitor a specific cookie
    function monitorCookie(cookieName, interval = 1000, callback) {
        let previousValue = getCookieValue(cookieName);  // Initial cookie value

        setInterval(() => {
            const currentValue = getCookieValue(cookieName);  // Current cookie value

            // Check if the cookie value has changed
            if (currentValue !== previousValue) {
                previousValue = currentValue;  // Update the previous value
                console.log(`Cookie value for "${cookieName}" changed to: ${currentValue}`);

                // Optional: Trigger a callback if provided
                if (callback) {
                    callback(currentValue);
                }
            }
        }, interval);
    }

    function deleteAllCookies() {
        // Get all cookies
        const cookies = document.cookie.split(";");

        // Loop through each cookie and delete it
        cookies.forEach(cookie => {
            const cookieName = cookie.split("=")[0].trim();
            document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        });

        console.log('All cookies have been deleted.');
    }

    useEffect(() => {
        monitorCookie('appState', 1000, (newValue) => {
            console.log('Detected new cookie value:', newValue);
            if (newValue === "hasNoFeedback") {
                setTimeout(() => {
                    deleteAllCookies()
                    window.location.reload()
                }, 3000);

            }
        });
    }, [])

    useEffect(()=>{
        // Append Google Tag Manager script to the head
        const googleScript = document.createElement('script');
        googleScript.type = 'text/javascript';
        googleScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-K4R3DS92');`;
        document.head.appendChild(googleScript);

        // Create the noscript element
        const googleNoScript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-K4R3DS92';
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        googleNoScript.appendChild(iframe);
        document.body.appendChild(googleNoScript);

        const googleScript1 = document.createElement('script');
        googleScript1.async = true;
        googleScript1.src = 'https://www.googletagmanager.com/gtag/js?id=G-9JRRHXKR0S';

        // Create the second script tag
        const ggogleScript2 = document.createElement('script');
        ggogleScript2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-9JRRHXKR0S');
        `;

        // Append the script tags to the document head
        document.head.appendChild(googleScript1);
        document.head.appendChild(ggogleScript2);
        
        // Cleanup on unmount
        return () => {
            document.head.removeChild(googleScript);
            document.head.removeChild(googleScript1);
            document.head.removeChild(ggogleScript2);
            document.body.removeChild(googleNoScript);
        };
    },[])

    return (
        <div className={`nisg ${temp1 ? "nisg-aside-mob" : ""}`} >
            {isScannerOpen || isScannerWhatsapp ? <div className='scanner-backdrop'> </div> : ""}
            <div className={`main ${(isRight || temp) ? "mainFw" : ""}`}>
                <div className={`contents ${isRight ? "contentsFw" : ""}`}>
                    <div className={`title ${isRight ? "titleFw" : ""}`}>
                        <div className={`logo ${isRight ? "logoFw" : ""}`}>
                            <img src={logo} alt="Logo" />
                        </div>
                        <h1 className={`nisg-heading ${isRight ? "nisg-headingFw" : ""}`}>IP Care Centre</h1>
                    </div>
                    {!temp && <p className='nisg-sub-heading'>Welcome to One-Stop Solution for Intellectual Property Queries</p>}
                    {temp && <p className='nisg-sub-heading'>Welcome to One-Stop Solution for <br /> Intellectual Property Queries</p>}

                    <section
                        className={`intro ${isRight ? "introFw" : ""}`}

                    >
                        {!temp && <h3 className='intro-heading'> Introducing IP Saarthi, Your AI-Powered Assistant</h3>}
                        {temp && <h3 className='intro-heading'> Introducing IP Saarthi,<br /> Your AI-Powered Assistant</h3>}
                        <p className={`intro-text ${isRight ? "intro-textFw" : ""}`}>
                            Discover IP Saarthi, your intelligent virtual assistant, designed to assist
                            you with your intellectual property queries. With IP Saarthi, you can access
                            information, resolve issues, and get expert guidance efficiently.
                        </p>
                    </section>
                    <section className={`connections ${isRight ? "connectionsFw" : ""}`}>
                        <div className={`connect-social ${isRight ? "connect-socialFw" : ""}`}>
                            <div className='connect cp' style={{ width: "160px", margin: `${isRight ? "0 auto" : "0"}`, justifyContent: "center" }} onClick={() => handleChannelButton()}>
                                <div className='connect-img'>
                                    <img src={bot} alt="robot-logo" />
                                </div>
                                <div className='connect-text' >
                                    <div className='connect-title'>Chat With</div>
                                    <div className='connect-sub-title'>IP Saarthi</div>
                                </div>
                            </div>

                            {/* <div className={`connect ${isScannerWhatsapp ? "active" : ""}`}>
                                <div className='connect-img opacity'>
                                    <img src={whatsApp} alt="robot-logo" />
                                </div>
                                <div className='connect-text'>
                                    <div className='connect-title'><span className='coming-soon'>Coming Soon</span> On</div>
                                    <div className='connect-sub-title opacity'>WhatsApp</div>
                                    {!temp && <div className='sm-scanner cp' onClick={() => setIsScannerWhatsapp(true)}>
                                        <img src={smScanner} alt="sm-scanner" />
                                    </div>}
                                    {isScannerWhatsapp &&
                                        <>
                                            <div className='scanner-backdrop' onClick={() => setIsScannerWhatsapp(false)}> </div>
                                            <div className='fullscreen-overlay'>
                                                <img src={comingSoonScanner} alt="qr" width={250} height={300} />
                                                <div className='close-icon'>
                                                    <img src={closeIcon} alt="close" onClick={() => setIsScannerWhatsapp(false)} />
                                                </div>
                                                <div className='scanner-coming-soon'>Coming Soon</div>
                                                <div className='scanner-layout'>
                                                    Scan QR <br />to chat on WhatsApp</div>
                                                <div className='QR'><img src={QRScanner} alt="qr" /></div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className={`connect ${isScannerOpen ? "active" : ""}`}>
                                <div className='connect-img opacity'>
                                    <img src={telegram} alt="robot-logo" />
                                </div>
                                <div className='connect-text'>
                                    <div className='connect-title'><span className='coming-soon'>Coming Soon</span> On</div>
                                    <div className='connect-sub-title opacity'>Telegram</div>
                                    {!temp && <div className='sm-scanner cp' onClick={() => setIsScannerOpen(true)}>
                                        <img src={smScanner} alt="sm-scanner" />
                                    </div>}
                                    {isScannerOpen &&
                                        <>
                                            <div className='scanner-backdrop' onClick={() => setIsScannerOpen(false)} > </div>
                                            <div className='fullscreen-overlay'>
                                                <img src={comingSoonScanner} alt="qr" width={250} height={300} />
                                                <div className='close-icon'>
                                                    <img src={closeIcon} alt="close" onClick={() => setIsScannerOpen(false)} />
                                                </div>
                                                <div className='scanner-coming-soon'>Coming Soon</div>
                                                <div className='scanner-layout'>
                                                    Scan QR <br />to chat on Telegram</div>
                                                <div className='QR'><img src={QRScanner} alt="qr" /></div>

                                            </div>
                                        </>
                                    }
                                </div>
                            </div> */}

                        </div>
                        {/* <div className={`connect-social ${isRight ? "connect-socialFw" : ""}`}>
                            <div className='connect'
                            //  onClick={() => window.location.href = 'tel:18001114444'}
                            >
                                <div className='connect-img opacity'>
                                    <img src={caller} alt="robot-logo" />
                                </div>
                                <div className='connect-text'>
                                    <div className='connect-title'><span className='coming-soon'>Coming Soon</span> On</div>
                                    <div className='connect-sub-title opacity'>1800 111 4444</div>
                                </div>
                            </div>
                            <div className='connect'
                            //  onClick={() => window.location.href = 'mailto:auto@ipr.gov.in'}
                            >
                                <div className='connect-img opacity'>
                                    <img src={message} alt="robot-logo" />
                                </div>
                                <div className='connect-text'>
                                    <div className='connect-title'><span className='coming-soon'>Coming Soon</span> At</div>
                                    <div className='connect-sub-title opacity'>auto@ipr.gov.in</div>
                                </div>
                            </div>
                        </div> */}
                    </section>
                </div>
                <div className='learn-more-parent'>
                    {!temp && <>
                        <span className={`learn-more ${isRight ? "learn-moreFw" : ""}`} onClick={() => setIsRight(!isRight)}>{isRight ? "Learn more" : ""}</span>
                        <span
                            className={`arrow-right ${isRight ? "arrow-left" : ""}`}
                            onClick={() => {
                                setIsRight(!isRight);
                            }}
                        >
                            <img src={arrowRight} alt="Logo" />
                        </span>
                    </>}
                    {temp && <>
                        <span className={`learn-more ${temp1 ? "" : "learn-moreFw"}`} onClick={() => {
                            setTemp1(!temp1);
                        }}>{temp1 ? "Go back" : "Learn more"}</span>
                        <span
                            className={`arrow-right ${temp1 ? "" : "arrow-left"}`}
                            onClick={() => {
                                setTemp1(!temp1);
                            }}
                        >
                            <img src={arrowRight} alt="Logo" />
                        </span>
                    </>}

                </div>
                <div className={`robot ${isRight ? "robotFw" : ""}`}>
                    <img className="robot-icon" src={robot} alt="Robot Icon" />
                </div>
            </div >
            <aside className={`aside ${isRight ? "asideNone" : ""}`}>
                <div className='aside-logo'>
                    <img src={asideLogo} alt="Logo" />
                </div>
                <h2 className='aside-title'>How IP Saarthi Can Help You</h2>
                <ul className='aside-list'>
                    <li>
                        <div className='aside-text'>Comprehensive Information:</div>
                        <div className='aside-sub-text'>
                            Find answers to your questions about patents, trademarks, copyrights, and more.
                        </div>
                    </li>
                    <li>
                        <div className='aside-text'>Quick and Easy Support:</div>
                        <div className='aside-sub-text'>
                            Find answers to your questions about patents, trademarks, copyrights, and more.
                        </div>
                    </li>
                    <li>
                        <div className='aside-text'>Multiple Channels:</div>
                        <div className='aside-sub-text last-el'>
                            Connect with IP Saarthi through your preferred channel: website chat, WhatsApp,
                            Telegram, IVR, or email.
                        </div>
                    </li>
                </ul>
                <h2 className='aside-title'>Key Features</h2>
                <ul className='aside-list'>
                    <li>
                        <div className='aside-text'>24/7 Availability:</div>
                        <div className='aside-sub-text'>Access support anytime, anywhere.</div>
                    </li>
                    <li>
                        <div className='aside-text'>Multiple Language Support:</div>
                        <div className='aside-sub-text'>Interact with IP Saarthi in your preferred language.</div>
                    </li>
                    <li>
                        <div className='aside-text'>User-Friendly Interface:</div>
                        <div className='aside-sub-text'>Enjoy a seamless and intuitive experience.</div>
                    </li>
                    <li>
                        <div className='aside-text'>Data Privacy:</div>
                        <div className='aside-sub-text'>
                            Your information is safeguarded with robust security measures.
                        </div>
                    </li>
                </ul>
            </aside>
            <div className={`modal-overlay ${modalChatBot ? "show" : ""}`} onClick={handleCloseChatBot}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className='modal-close-button' onClick={() => {
                            setModalChatBot(false);
                            window.location.reload();
                        }}>
                            <img src={modalClose} alt="modal-close" />
                        </div>
                        {modalChatBot && <NISGComp />}
                        <div className='modal-footer-kalpai'>
                            Implemented by <strong>NISG</strong> using <strong>talkk</strong><img src={aiRightArrow} alt='talk-right-arrow' /><span>.ai</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal-overlay ${modalBot ? "show" : ""}`} onClick={handleClose}>
                <div className="modal-content">
                    <div className="disclaimer-modal-body">
                        <div className='modal-close-button' onClick={() => setModalBot(false)}>
                            <img src={modalClose} alt="modal-close" />
                        </div>
                        <div className='disclaimer-modal'>
                            <div className='disclaimer-modal-header'>Disclaimer</div>
                            <div className='discalimer-body'>
                                <div className='disclaimer-modal-text'>The information provided by this chatbot is intended for general informational purposes only and should not be construed as legal, financial, or professional advice. While we strive to ensure the accuracy and relevance of the information provided, it is subject to change, and may not always reflect the most current laws, regulations, or policies.<br /> This chatbot is not a substitute for professional consultation, and the information it provides does not constitute legal evidence or form the basis for legal action. Users are advised to consult with appropriate professionals, such as legal advisors or experts in the relevant field, for guidance or to obtain legally binding advice. By using this service, you acknowledge and agree that the chatbot’s responses are for informational use only and should not be relied upon for making legal decisions or serving as legal evidence in any formal proceedings.
                                </div>
                                <div className='disclaimer-accept check-box-wrap'>
                                    <label className="container custom-checkbox">
                                        <input type="checkbox" onChange={(e) => setDisclaimerSelected(e.target.checked)} />
                                        <span className="checkmark"><span className='checkmark-inner'></span></span>
                                        I accept and wish to continue
                                    </label>
                                </div>
                                <button className='disclaimer-button' style={{ cursor: disclaimerSelected ? "pointer" : "not-allowed" }} onClick={handleChatButton}>
                                    Continue With Chat
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default NISG;
